import { styled } from '@mui/material/styles';
import React from 'react';

const PREFIX = 'ColorIndicator';

const classes = {
  colorIndicator: `${PREFIX}-colorIndicator`,
  big: `${PREFIX}-big`,
  small: `${PREFIX}-small`
};

const Root = styled('div')(({ theme }) => ({
  [`& .${classes.colorIndicator}`]: {
    display: 'block',
    float: 'left',
    marginLeft: parseFloat(theme.spacing(1)),
    marginRight: parseFloat(theme.spacing(1)),
    borderRadius: '2px',
    '&:hover': {
      cursor: 'pointer'
    }
  },

  [`& .${classes.big}`]: {
    height: '24px',
    width: '24px',
    minWidth: '24px',
    '&:hover': {
      height: '32px',
      width: '32px',
      minWidth: '32px',
      marginLeft: parseFloat(theme.spacing(1)) - 4,
      marginRight: parseFloat(theme.spacing(1)) - 4
    }
  },

  [`& .${classes.small}`]: {
    height: '18px',
    width: '18px',
    minWidth: '18px',
    '&:hover': {
      height: '24px',
      width: '24px',
      minWidth: '24px',
      marginLeft: parseFloat(theme.spacing(1)) - 3,
      marginRight: parseFloat(theme.spacing(1)) - 3
    }
  }
}));

interface ColorIndicatorProps {
  color: string;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  variant?: string;
}

const ColorIndicator = ({ color, onClick, variant = 'small' }: ColorIndicatorProps) => {
  return (
    <Root>
      <span
        className={`${classes.colorIndicator} ${variant === 'big' ? classes.big : classes.small}`}
        onClick={onClick}
        style={{
          backgroundColor: color
        }}
        aria-label="Open"
        role="menuitem"
        tabIndex={0}
        onKeyPress={() => console.log('key pressed')}
      />
    </Root>
  );
};

export default ColorIndicator;
